/**
 * @desc generate the content and classname for the meat sticker
 *
 * @param {number} promoOfferTypeCode type of linksave
 * @param {string} promoQty quantity of linksave
 * @param {string} promoValue value of linksave
 *
 * @returns {array} slices with content and classname
 */
const formatMeatSticker = (promoOfferTypeCode, promoQty, promoValue) => {
  const FONT_SMALL = 'font-small'
  const HEIGHT_NORMAL = 'height-normal'
  const INLINE_BLOCK = 'inline-block'
  const DOWN_LARGE = 'down-large'

  switch (promoOfferTypeCode) {
    case 8: {
      return [
        {
          content: `Buy ${promoQty} save `,
          mods: ['block', FONT_SMALL, 'center', HEIGHT_NORMAL],
        },
        {
          content: promoValue,
          mods: ['block', 'font-large', 'up-small'],
        },
      ]
    }
    case 13: {
      return [
        {
          content: `${promoQty} `,
          mods: [INLINE_BLOCK, 'font-huge', HEIGHT_NORMAL, DOWN_LARGE, 'font-weight-semi-bold'],
        },
        {
          content: ' for ',
          mods: [INLINE_BLOCK, FONT_SMALL, DOWN_LARGE, 'margin-horizontal-small'],
        },
        {
          content: ` ${promoValue}`,
          mods: [INLINE_BLOCK, 'font-huge', DOWN_LARGE, 'font-weight-semi-bold'],
        },
      ]
    }
    case 15: {
      const promoValueSize = promoValue.length > 5 ? 'font-large' : 'font-huge'
      return [
        {
          content: `${promoQty} for `,
          mods: ['block', 'font-normal', 'center', HEIGHT_NORMAL],
        },
        {
          content: promoValue,
          mods: ['block', promoValueSize, 'up-small'],
        },
      ]
    }
    default: {
      return [
        {
          content: `${promoQty} for`,
          mods: ['block', FONT_SMALL],
        },
        {
          content: promoValue,
        },
      ]
    }
  }
}

export { formatMeatSticker as default }



// WEBPACK FOOTER //
// ./shared/interim/product/link-save-primary-banner/linksave-config.js